import { json } from 'd3-fetch'
import Url from 'domurl'
import { update } from './update'
import * as storage from './storage'

export const click = (node: object): void => {
  if (node.cardable === true) layoverController().load(node.id, 'card')
  if (node.highlightable === true) highlight(node)
  if (node.centerable === true && node.draggable !== true) center(node)
  if (node.loadNeighborable === true) loadNeighbors(node)
}

export const unclick = (...options: string[]): void => {
  if (!options.includes('keepHighlight')) clearHighlight()
  if (!options.includes('keepCenter')) clearCenter()
}

export const doubleclick = (node: object): void => {
  if (node.drillDownable === true) drillDown(node)
}

const layoverController = (node: object): object => {
  return globalThis._APPLICATION_.getControllerForElementAndIdentifier(document.getElementById('layover'), 'layover')
}

const highlight = (node: object): void => {
  if (node.highlightable !== true) return
  clearHighlight()
  globalThis._CONFIGURATION_.highlighted = [node.id, node.adjacentNodeIds].flat()
}

const clearHighlight = (): void => {
  globalThis._CONFIGURATION_.highlighted = null
  layoverController().clear()
}

const center = (node: object): void => {
  if (node.centerable !== true) return
  clearCenter()
  globalThis._CONFIGURATION_.centered = node.id
}

const clearCenter = (): void => {
  globalThis._CONFIGURATION_.centered = null
}

const loadNeighbors = (node: object): void => {
  const url = window.location.origin.concat('', `/api/v2/nodes/${String(node.id)}/neighbors.json`)
  json(url.toString()).then(async function (data) {
    data.nodes.forEach(n => {
      n.x = node.x
      n.y = node.y
    })
    return storage.patch(data.nodes, data.links)
  }).then((change) => {
    if (change.nodesChanged === false && change.linksChanged === false) return Promise.reject('No new nodes or links') // eslint-disable-line
  }).then(() => globalThis._SIMULATION_.alpha(0.05).alphaDecay(0.01).alphaTarget(0).restart())
    .then(() => update())
    .catch((error) => console.error(error))
}

const drillDown = (node: object): void => {
  const url = new Url(globalThis._CONFIGURATION_.url)
  url.query.hub_type = node.nodeTypeId
  url.query.hub = node.id
  location.href = url.toString()
}
